import { administracionSections } from './administracionSections';

export const administracionManual = {
  id: 'mod-administracion',
  title: 'Administración',
  isVisible: (ctx) => ctx.limitedScope.showAdministracion,
  intro:
    'Trazabilidad transversal, resultados, tipos de cambio, registro de actividad e informe de rendimiento por usuario. Documentación alineada al menú Administración.',
  sections: administracionSections,
};
